module.exports = __webpack_public_path__ + "img/stellar.78d57534.png";